export const NATIVE_GA_WORKER_LIB_PATH = "/~partytown/";
export const NATIVE_GA_WORKER_SANDBOX_PATH = `${NATIVE_GA_WORKER_LIB_PATH}partytown-sandbox-sw.html`;

export const PERFORMANCE_CRITICAL_PATHS = [
  "/",
  "/ai-astrologer",
  "/ai-kundli",
  "/account",
  "/ascendant-calculator",
  "/baby-names",
  "/birth-chart",
  "/career-astrology",
  "/dasha-calculator",
  "/dasamsa",
  "/dwadasamsa",
  "/free-kundali",
  "/gun-milan",
  "/hi/baby-names",
  "/hi/dasamsa",
  "/hi/free-kundali",
  "/hi/gun-milan",
  "/hi/kundli-matching",
  "/hi/mangal-dosha-calculator",
  "/hi/mulank-calculator",
  "/hi/muft-jyotish-chat",
  "/hi/name-numerology",
  "/hi/numerology",
  "/hi/rashi-calculator",
  "/hi/tithi-today",
  "/kundli-matching",
  "/lal-kitab-kundli",
  "/mangal-dosha-calculator",
  "/muhurat/travel",
  "/nakshatra-calculator",
  "/name-numerology",
  "/numerology",
  "/panchang",
  "/prashna-kundali",
  "/rashifal",
  "/rashi-calculator",
  "/sade-sati",
  "/saptamsa",
  "/shashtiamsa",
  "/tithi-today",
  "/trimsamsa",
] as const;

const PERFORMANCE_CRITICAL_PATH_SET = new Set<string>(PERFORMANCE_CRITICAL_PATHS);

export function normalizePerformancePath(pathname: string): string {
  if (pathname === "/") return pathname;
  return pathname.endsWith("/") ? pathname.slice(0, -1) : pathname;
}

export function isPerformanceCriticalPath(pathname: string): boolean {
  return PERFORMANCE_CRITICAL_PATH_SET.has(normalizePerformancePath(pathname));
}
